import * as React from 'react';
import parse from 'html-react-parser';
import { Button } from '@mui/material';

function HTMLWidget({ sSystemName, cMake, pSetCurrentTab }) {
    let systemConfig = require('../config/' + sSystemName + '.json');
    let systemCSS = require('../config/' + sSystemName + '.css');

    let sHtml = cMake.asHtml.join("");

    // Function to replace <button> in HTML with Material-UI Button
    const options = {
        replace: (domNode) => {
            if (domNode.name === 'button' && cMake.sTabIndex) {
                return (
                    <Button
                        variant="contained"
                        onClick={() => pSetCurrentTab(cMake.sTabIndex)}
                    >
                        {cMake.sTabName}
                    </Button>
                );
            }
        }
    };

    return <div className="html-widget-container">{parse(sHtml, options)}</div>;
}

export default HTMLWidget;
